<template>
  <div class="exportinfo">
    <p class="xx">{{pj}}</p>
    <el-form @submit.native.prevent>
      <el-form-item class="export">
        <el-button size="mini"
                   @click="exportData"
                   type="primary">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'exportData',
  data () {
    return {
      search: "",
      pj: '当前所属信息为：'
    }
  },
  props: ['dwform', 'selectdata', 'Field', 'isout'],
  methods: {
    exportData () {
      /* const dataField = {
        title: ["名称", "总分", "本地区排名", "全国排名"],
        enname: ["mc", "zf", "bdqpm", "qgpm"]
      } */
      console.log(this.isout);
      if (this.isout == true) {
        switch (this.dwform.type) {
          case 5:
            window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputMember&department=" + this.dwform.department)
            break;
          case 4:
            window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputRegion&region=" + this.dwform.region + "&city=" + this.dwform.city + "&dist=" + this.dwform.dist)
            break;
          case 3:
            window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputRegion&region=" + this.dwform.region + "&city=" + this.dwform.city)
            break;
          case 2:
            window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputRegion&region=" + this.dwform.region)
            break;
          case 1:
            window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputRegion&lsgx=" + this.dwform.department)
            break;
        }
      } else if (this.isout == false) {
        if (this.selectdata !== undefined) {
          this.creatExcel_detail(this.Field, "数据导出", this.selectdata)
        } else {
          this.$message.error('没有数据无法导出');
        }
      } else if (this.isout == 'dq') {
        window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputRegion&region=" + this.dwform.region + "&city=" + this.dwform.city + "&dist=" + this.dwform.dist)
      } else if (this.isout == 'dq2') {
        window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputRegion&lsgx=" + this.dwform.lsgx)
      } else {
        window.open("https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&a=outputMember&department=" + this.dwform.department)
      }
    },
    creatExcel_detail (dataField, title, portlist) {
      // 要导出的json数据
      // debugger
      let jsonData = portlist
      /* let reduceData = {} */
      let strtitle = ""
      /* let strtdredduce = '' */
      // 列标题
      for (const key of dataField.title) {
        // 增加\t为了不让表格显示科学计数法或者其他格式
        strtitle += `<td class="title">${key}</td>`;
      }

      let str = '<tr style=" font-weight: bold;" >' + strtitle + '</tr>';
      // 循环遍历，每行加入tr标签，每个单元格加td标签
      for (let i = 0; i < jsonData.length; i++) {
        str += '<tr>';
        for (const key of dataField.enname) {
          // 增加\t为了不让表格显示科学计数法或者其他格式
          //  if (!jsonData[i][key]) jsonData[i][key] = '';
          str += `<td>${jsonData[i][key] + '\t'}</td>`;
        }
        str += '</tr>';
      }
      const worksheet = 'Sheet1'
      /* const uri = 'data:application/vnd.ms-excel;base64,'; */

      // 下载的表格模板数据
      const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
               xmlns:x="urn:schemas-microsoft-com:office:excel"
               xmlns="http://www.w3.org/TR/REC-html40">
               <head><meta charset='UTF-8'><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
               <x:Name>${worksheet}</x:Name>
               <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
               </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
               <style>
               .title{
                 // background-color:#2af;
                 // color:#fff;
                 // font-weight:700;
                 }
                 td {
                  text-align:center;
                  border:0.5px solid #ccc;
                  vnd.ms-excel.numberformat:@;
                 }
                </style>
               </head>

               <body>
               <table>${str}</table>

               </body>
               </html>


               `;
      const link = document.createElement('a')
      let blob = new Blob([template], { type: 'application/vnd.ms-excel' })
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      //link.download = res.headers['content-disposition']
      link.download = "【" + title + "】"  //下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    pjj () {
      if (this.dwform.lsgx !== "") {
        this.pj = this.pj + this.dwform.lsgx
      }
      if (this.dwform.region !== '') {
        this.pj = this.pj + this.dwform.region
      }
      if (this.dwform.city !== '') {
        this.pj = this.pj + '-' + this.dwform.city
      }
      if (this.dwform.dist !== '') {
        this.pj = this.pj + '-' + this.dwform.dist
      }
      if (this.dwform.type==6) {
        this.pj=this.pj + this.dwform.department
      }
    }
  },
  mounted () {
    this.pjj()
  }
}
</script>

<style lang="less" scoped>
.exportinfo {
  display: flex;
  align-items: center;
  margin-right: 40px;
}
.el-form-item {
  margin-bottom: 0;
}

.el-form {
  margin-left: 20px;
}
.xx {
  /* width: 300px; */
}
</style>